import { render, staticRenderFns } from "./BulletinModal.vue?vue&type=template&id=4c637e13"
import script from "./BulletinModal.vue?vue&type=script&lang=js"
export * from "./BulletinModal.vue?vue&type=script&lang=js"
import style0 from "./BulletinModal.vue?vue&type=style&index=0&id=4c637e13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports